import { uiText, useUiLanguage } from '../../utils/uiTranslation';
import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import SubscriptionPopup from '../applicants/SubscriptionPopup';
import './Trial.css';

const TrialBanner = ({ trial }) => {
  useUiLanguage();
  const { currentUser } = useAuth();
  const [timeRemaining, setTimeRemaining] = useState('');
  const [showSubscriptionPopup, setShowSubscriptionPopup] = useState(false);

  useEffect(() => {
    const updateTime = () => {
      const now = Date.now();
      const remaining = trial.expiresAt - now;

      if (remaining <= 0) {
        setTimeRemaining('Trial expired');
        return;
      }

      const days = Math.floor(remaining / (24 * 60 * 60 * 1000));
      const hours = Math.floor((remaining % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
      
      if (days > 0) {
        setTimeRemaining(`${days} day${days === 1 ? '' : 's'}`);
      } else if (hours > 0) {
        setTimeRemaining(`${hours} hour${hours === 1 ? '' : 's'}`);
      } else {
        const minutes = Math.floor((remaining % (60 * 60 * 1000)) / (60 * 1000));
        setTimeRemaining(`${minutes} minute${minutes === 1 ? '' : 's'}`);
      }
    };

    updateTime();
    const interval = setInterval(updateTime, 60000);
    return () => clearInterval(interval);
  }, [trial.expiresAt]);

  const daysLeft = trial.daysRemaining || 0;
  const urgencyClass = daysLeft <= 2 ? 'urgent' : daysLeft <= 7 ? 'warning' : 'normal';
  
  // Determine icon and color based on urgency
  let iconClass = 'fa-solid fa-gift';
  let iconColor = '#667eea';
  
  if (daysLeft <= 2) {
    iconClass = 'fa-solid fa-clock';
    iconColor = '#ff6b6b';
  } else if (daysLeft <= 7) {
    iconClass = 'fa-solid fa-hourglass-half';
    iconColor = '#ffa94d';
  }

  return (
    <>
      <div className={`trial-banner ${urgencyClass}`}>
        <div className="trial-banner-content">
          <div className="trial-banner-icon">
            <i className={iconClass} style={{ color: iconColor }}></i>
          </div>
          <div className="trial-banner-text">
            <strong>{timeRemaining}</strong>{uiText(" left in your free trial")}{daysLeft <= 2 && <span className="trial-banner-urgent">{uiText("Expires soon!")}</span>}
          </div>
        </div>
        <button 
          onClick={() => setShowSubscriptionPopup(true)}
          className="trial-banner-button"
        >
          <i className="fa-solid fa-arrow-up" style={{ marginRight: '6px' }}></i>{uiText("Upgrade Now")}</button>
      </div>

      {/* Subscription Popup */}
      {showSubscriptionPopup && (
        <SubscriptionPopup
          isOpen={showSubscriptionPopup}
          onClose={() => setShowSubscriptionPopup(false)}
          userUID={currentUser?.uid}
        />
      )}
    </>
  );
};

export default TrialBanner;

